export default __webpack_public_path__ + "static/20-megacorporation-0e1ce4dcf3d8799494e6467cf9896750.png";